<template>
  <v-dialog
    v-model="dialog"
    attach="#app"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot
        name="activator"
        v-bind="{ on, attrs }"
      ></slot>
    </template>
    <v-card
      :style="{
        position: 'relative',
        height: $vuetify.breakpoint.height - 100 + 'px'
      }"
    >
      <v-btn
        @click="dialog = false"
        text
        :style="{
          position: 'absolute',
          top: '25px',
          right: '55px',
          zIndex: 99
        }"
        ><v-icon left>mdi-close</v-icon> close</v-btn
      >
      <div style="height: 100% !important; overflow: auto">
        <v-img
          contain
          :src="value"
        ></v-img>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "PicturePreview",
  props: {
    value: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      dialog: false
    }
  },
  methods: {
    cancel() {
      this.dialog = false
    }
  }
}
</script>
